/**
 * canDrop — drop validation hook for the kanban board.
 *
 * Default ruleset: allow every transition. Return `true` or `false`.
 * Return `{ reason: string }` to surface the message in the rejection toast.
 *
 * Future business rules (e.g., block 'done' when subtasks open) plug in
 * here without re-architecting the board. The board calls this in onDragEnd
 * before mutating; a false return path reverts state, flashes the source
 * card, and shows the toast.
 */
export type ActiveTask = {
  id: string;
  status: "backlog" | "todo" | "doing" | "done";
  subtaskCount: number;
  subtaskCompletedCount: number;
};

export type OverTarget = {
  columnId: string;
  index: number;
};

export type DropContext = {
  active: ActiveTask;
  over: OverTarget | null;
};

export type DropResult = boolean | { reason: string };

export function canDrop(
  _active: ActiveTask,
  _over: OverTarget | null,
): DropResult {
  // Default: allow every transition. Future rules attach here.
  return true;
}
